import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyMainSkin } from "../../../../actions/mine_craft/mainSkinsActions";
import { useNavigate } from "react-router-dom";
import { selectMainSkinEntities, selectMainSkinIds, setEditId } from "../../../../store/mine_craft/mainSkinsSlice";
import usePermissions from "../../../../hooks/usePermissions";

import { message, Spin } from "antd";
import { LikeOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonDownload, ButtonEdit } from "../../../../componets/Buttons";
import {formattedDate} from "../../../../helpers/DateHelpers";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const ids             = useAppSelector(selectMainSkinIds);
  const mainSkins  = useAppSelector(selectMainSkinEntities);
  const count           = useAppSelector(state => state.mineCraft.mainSkins.count);
  const error           = useAppSelector(state => state.mineCraft.mainSkins.error);
  const status          = useAppSelector(state => state.mineCraft.mainSkins.status);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyMainSkin(id));

    if (destroyMainSkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyMainSkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderMainSkin = (id: EntityId) => {
    const mainSkin = mainSkins[id];

    if (!mainSkin) {
      return;
    }
    const formattedCreatedAt = formattedDate(mainSkin.created_at);

    return (
      <CardImage
        key={mainSkin.id}
        image={mainSkin.thumbnail_url}
        title={mainSkin.title}
        link={mainSkin.url}
        stats={[
          <IconText icon={LikeOutlined} text={mainSkin.likes_count} />,
          <IconText icon={MessageOutlined} text={mainSkin.comments_count} />
        ]}
        options={[
          ...(mainSkin.image_url ? [<ButtonDownload key={`download-${mainSkin.id}`} href={mainSkin.image_url} />] : []),
          ...(write_minecraft ? [
            <ButtonEdit key={`edit-${mainSkin.id}`} onClick={() => onClickEdit(mainSkin.id)} />,
            <ButtonDestroy key={`destroy-${mainSkin.id}`} onClick={() => onClickDestroy(mainSkin.id)} />
          ] : [])
        ]}>
        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderMainSkin)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
